import { FETCH_ALL_STOCKS,
FETCH_PAGINATE_STOCKS,
FETCH_CURRENT_STOCK,
FETCH_CURRENT_STOCK_PRODUCTS,
REFRESH_STOCK_PRODUCTS,
PUSH_TO_STOCK_PRODUCTS,
PUSH_TO_STOCK_PRODUCTS_CUSTOM,
FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM,
REFRESH_STOCK_PRODUCTS_CUSTOM,
UPDATE_TO_STOCK_PRODUCTS,
DELETE_TO_STOCK_PRODUCTS,
EDIT_TO_STOCK_PRODUCTS,
SET_STOCK_SELECTED_WAREHOUSE,
DELETE_FROM_STOCK_PRODUCTS_CUSTOM,
} from './../../mutation-types';
import Vue from 'vue';

export default {
  [FETCH_ALL_STOCKS](state, stocks) {
    state.all = stocks;
  },

  [FETCH_PAGINATE_STOCKS](state, { stocks, pagination }) {
    state.items = stocks;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_STOCK](state, stock) {
    state.currentStock = stock;
  },

  [FETCH_CURRENT_STOCK_PRODUCTS](state, products) {
    state.stockProducts = products;
  },

  [PUSH_TO_STOCK_PRODUCTS](state, product) {
    state.stockProducts.push(product);
  },

  [REFRESH_STOCK_PRODUCTS](state) {
    state.stockProducts = [];
  },

  [EDIT_TO_STOCK_PRODUCTS](state, { data, i }) {
    state.stockProducts[i] = data;
  },

  [REFRESH_STOCK_PRODUCTS_CUSTOM](state) {
    state.stockProductsCustom = [];
  },

  [FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM](state, products) {
    state.stockProductsCustom = products;
  },

  [UPDATE_TO_STOCK_PRODUCTS](state, { data, i }) {
    Vue.set(state.stockProductsCustom, i, data);
  },

  [DELETE_TO_STOCK_PRODUCTS](state, i) {
    state.stockProducts.splice(i, 1);
  },

  [PUSH_TO_STOCK_PRODUCTS_CUSTOM](state, product) {
    state.stockProductsCustom.push(product);
  },

  [DELETE_FROM_STOCK_PRODUCTS_CUSTOM](state, i) {
    state.stockProductsCustom.splice(i, 1);
  },

  [SET_STOCK_SELECTED_WAREHOUSE](state, warehouseId) {
    state.warehouseId = warehouseId;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/stock/mutations.js